<template>
	<div class="actions">
		<div class="actions-bar">
			<div class="action-content">
				<button
					type="button"
					class="action"
					v-for="(action, index) in actions"
					v-bind:class="{ active: action.active }"
					v-bind:style="setBorder(action)"
					v-on:click="actionToDo(action)"
					:key="index">
					<v-icon v-if="action.icon" color="white" class="action-icon">{{action.icon}}</v-icon>
					<img
						v-else-if="action.img"
						v-bind:src="action.img"
						alt=""
						class="action-logo"
					>
					<p class="action-txt" :style="setMaxWidth(action)">{{ action.text }}</p>
				</button>
			</div>
		</div>
	</div>
</template>

<script>
function actionToDo(item) {
	const action = item.link ? item.link : {
		width: item.width ? item.width : 0,
		title: item.text,
		code: item.code,
		active: item.active,
		open: true,
	};
	const eventEmit = item.link ? 'to-link' : 'open-modal';
	this.$emit(eventEmit, action);
}

function setBorder(item) {
	const color = item.color === undefined ? '#9b9b9b' : item.color;
	return `border-bottom: 4px solid ${color}`;
}

function setMaxWidth(item) {
	const maxWidth = item.maxWidth ? `${item.maxWidth}px` : 'min-content';
	return `max-width: ${maxWidth}`;
}

export default {
	name: 'quick-actions',
	methods: {
		actionToDo,
		setBorder,
		setMaxWidth,
	},
	props: {
		actions: Array,
	},
};
</script>

<style lang="scss" scoped>
	.actions {
		background: transparent;
		display: flex;
		justify-content: center;
		margin: 0;
		position: fixed;
		right: 48px;
		top: 59px;
		width: fit-content;
		z-index: 4;

		.actions-bar {
			background: transparent;
			border: 0;
			border-radius: 7px;
			box-shadow: none;
			padding: 0;
			.action-content {
				@include flex-end;
				height: 36px;
				.action {
					@include flex-center;
					background: #1A4338;
					border: 0 !important;
					border-radius: 7px;
					box-shadow: 0 2px 6px rgba(26, 67, 56, .25);
					color: white;
					cursor: pointer;
					height: 32px;
					margin: 0;
					opacity: 0.3;
					outline: none;
					padding: 0 12px;
					text-align: center;
					transition: background-color .2s ease, box-shadow .2s ease, transform .2s ease;
					width: auto;

					.action-icon {
						color: white;
						font-size: 21px;
					}

					.action-logo {
						height: 21px;
						object-fit: contain;
						width: 21px;
					}

					.action-txt {
						@include txt-config (open-regular, small10);
						color: white;
						font-size: 13px;
						font-weight: 600;
						margin: 0 0 0 7px;
						max-width: none !important;
						text-align: left;
						white-space: nowrap;
					}
				}
				.action:hover,
				.action:focus {
					background: #12372E;
					box-shadow: 0 4px 10px rgba(26, 67, 56, .35);
					transform: translateY(-2px);
				}
				.active {
					opacity: 1;
				}
		}
	}

	@media (max-width: 900px) {
		.actions {
			margin: 7px auto 10px;
			max-width: calc(100% - 24px);
			position: relative;
			right: auto;
			top: auto;

			.actions-bar,
			.action-content { max-width: 100%; }
			.action-content { flex-wrap: wrap; height: auto !important; }
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/shared/quick-actions.vue